import { render, staticRenderFns } from "./Event-Form.vue?vue&type=template&id=59053b36&scoped=true"
import script from "./Event-Form.vue?vue&type=script&lang=js"
export * from "./Event-Form.vue?vue&type=script&lang=js"
import style0 from "./Event-Form.vue?vue&type=style&index=0&id=59053b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59053b36",
  null
  
)

export default component.exports